import { getIn } from "formik";

// Formik sağolsun array objelerinin validasyonlarını handle edemediği için
// bu şekilde bir fonksiyon yazılması gerekti.
export default (errors: any, touched: any, fieldName: any) => {
  const error = getIn(errors, fieldName);
  const touch = getIn(touched, fieldName);
  return touch && error ? error : null;
};
